import { render, staticRenderFns } from "./PlacementsDevelopmentItemReadOnly.vue?vue&type=template&id=3fecd968&"
import script from "./PlacementsDevelopmentItemReadOnly.vue?vue&type=script&lang=js&"
export * from "./PlacementsDevelopmentItemReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports